import { render } from "./PpcBudgetAllocationItem.vue?vue&type=template&id=74b13b8f&scoped=true"
import script from "./PpcBudgetAllocationItem.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocationItem.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocationItem.vue?vue&type=style&index=0&id=74b13b8f&lang=scss&scoped=true"
import "./PpcBudgetAllocationItem.vue?vue&type=style&index=1&id=74b13b8f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b13b8f"]])

export default __exports__